<form [formGroup]="form">
  <mat-select formControlName="type">
    <mat-optgroup
      *ngFor="let group of displayConditionTypes"
      [label]="group.name | translate">
      <mat-option
        *ngFor="let item of group.list"
        [value]="item.value" >
        {{ item.name | translate }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</form>
